import React from "react"
import PropTypes from "prop-types"
import { slugMaterialName } from "@utils/helpers"
import priceDownArrow from "@images/priceDownArrow.svg"
import priceUpArrow from "@images/priceUpArrow.svg"
import arrowBack from "@images/arrow_back_white.svg"
import MetaButton from "../MetaButton/version2"
import { useTranslation } from "react-i18next"
import { useBreakpoints } from "../../hooks/useBreakpoints"

const HeaderMetal = ({
  background,
  materialName,
  date,
  priceByParts,
  price,
  priceUp,
  currency,
  percentage,
  updated,
  countryName,
  unit,
  language,
  renderTitleAsH1 = false,
}) => {
  const { t } = useTranslation()
  const { isMobile, isTablet } = useBreakpoints()

  const getTitle = () => {
    return (
      <>
        {t(slugMaterialName(materialName) + "_material_name")}{" "}
        {!isMobile && <br />}
        {t("Scrap_Metal_Price")}
        {countryName.toLowerCase() !== "international"
          ? ` - ${t(countryName)}`
          : ""}{" "}
        <br />
        {date}
      </>
    )
  }

  return (
    <div
      className="
            min-h-[480px]
            font-inter

            md:min-h-[288px] 

            desk:min-h-[500px]"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <img
        src={background}
        className="
            h-[178px] 
            object-cover 
            w-full 

            md:hidden"
        alt={materialName}
      />

      <div
        className="
                flex 
                flex-col 
                justify-center
                
                md:flex-row 
                md:justify-between
				bg-dblue
				md:bg-opacity-80 "
      >
        <div
          className="
                    flex 
                    flex-col 
                    pl-4 
                    w-full
                    
                     

                    md:pl-5 
                    md:pr-5
                    md:justify-center 
                    md:ml-10 
                    md:w-[375px] 
                    md:min-h-[288px]  
                    

                    desk:w-[fit-content]
                    desk:min-w-[750px] 
                    desk:min-h-[500px]"
        >
          {renderTitleAsH1 ? (
            <h1 className="text-white text-24 mt-6 md:mt-0 desk:text-48">
              {getTitle()}
            </h1>
          ) : (
            <p className="text-white text-24  mt-6 md:mt-0 desk:text-48">
              {getTitle()}
            </p>
          )}
          <div
            className="
                    flex 
                    text-white 
                    items-baseline 

                    desk:mt-5"
          >
            {priceByParts.map(part => {
              if (part.type === "symbol") {
                return (
                  <p
                    className="
                        text-[16px] 
                        ml-1
                        
                        desk:text-[36px] "
                  >
                    {part.value}
                  </p>
                )
              } else if (part.type === "amount") {
                return (
                  <p
                    className="
                        font-medium
                        text-[36px] 

                        desk:text-[80px]"
                  >
                    {part.value}
                  </p>
                )
              }
            })}
            <p
              className=" 
                        text-[16px] 

                        desk:text-[36px]"
            >
              /{unit}{" "}
            </p>
            <p
              className="
                        opacity-80 
                        text-[16px] 
                        ml-4 

                        desk:text-[36px] 
                        desk:ml-7 "
            >
              {percentage}%{" "}
            </p>
            <img
              src={priceUp ? priceUpArrow : priceDownArrow}
              className="w-[16px] ml-1 desk:w-[36px] desk:ml-2"
              alt="price down arrow"
            />
          </div>
          <p
            className="
                    text-12 
                    text-sgray 
                    ml-1 
                    mt-0

                    desk:text-14"
          >
            {t("Disclaimer_Price")} {updated}
          </p>
        </div>
        <div
          className="
                
                ml-5 
                mt-5 
				mb-5

                md:mt-0 
                
                "
        >
          <MetaButton
            url={
              (language !== "en" ? `/${language}` : "") +
              "/scrap-metal-price/" +
              (countryName.toLowerCase() === "international"
                ? ""
                : slugMaterialName(countryName))
            }
            as="link"
            className="
                        h-12 
                        !border-white 
                        bg-dblue 
                        items-center 
                        text-14
                        w-140
                        inline-flex

                        md:m-15

                        desk:m-20 
                        desk:h-14 
                        desk:text-[18px] 
                        "
          >
            <div className="flex items-center">
              <img
                src={arrowBack}
                className="mr-1 h-6 desk:h-7 "
                alt={t("Scrap_Prices")}
              />
              {t("Scrap_Prices").toUpperCase()}
            </div>
          </MetaButton>
        </div>
      </div>
    </div>
  )
}

HeaderMetal.propTypes = {
  background: PropTypes.string,
  materialName: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  priceUp: PropTypes.bool.isRequired,
  currency: PropTypes.string.isRequired,
  percentage: PropTypes.string.isRequired,
  updated: PropTypes.string.isRequired,
  countryName: PropTypes.string.isRequired,
}

export default HeaderMetal
